import React from "react";
import styles from "./confirmation.module.css";
import { useRouter } from "next/router";
import Link from "next/link";
import Head from "next/head";

function ConfirmationPage({ status, message }) {
  return (
    <>
      <Head>
    <title>Event Subscription | School of Our Divine Infinite Being</title>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0"
    ></meta>
    <meta
      name="keywords"
      content="Event Subscription, Astrology Events, Tarot Workshops, Theurgy Rituals, Spiritual Seminars, Online Events, School of Our Divine Infinite Being"
    ></meta>
    <meta
      property="og:title"
      content="Subscribe to Our Events | School of Our Divine Infinite Being"
    ></meta>
    <meta property="og:type" content="website"></meta>
    <meta
      property="og:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/event_subscription_og_img.webp"
    ></meta>
    <meta
      property="og:image:alt"
      content="A mystical-themed calendar and a glowing celestial symbol, representing event subscriptions for a spiritual school of astrology and tarot."
    ></meta>
    <meta
      property="og:description"
      content="Subscribe to receive updates on all upcoming events, workshops, and rituals from the School of Our Divine Infinite Being. Don't miss out on our astrology and tarot sessions."
    ></meta>

    <meta property="og:image:width" content="1200"></meta>
    <meta property="og:image:height" content="627"></meta>
    <meta
      property="og:url"
      content="https://www.divineinfinitebeing.com/event-subscription"
    ></meta>

    <meta name="twitter:card" content="summary_large_image"></meta>
    <meta
      property="twitter:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/event_subscription_og_img.webp"
    ></meta>
    <meta
      property="twitter:image:alt"
      content="A mystical-themed calendar and a glowing celestial symbol, representing event subscriptions for a spiritual school of astrology and tarot."
    ></meta>
    <meta
      name="twitter:url"
      content="https://www.divineinfinitebeing.com/event-subscription"
    ></meta>
    <meta
      name="twitter:title"
      content="Subscribe to Our Events | School of Our Divine Infinite Being"
    ></meta>
    <meta
      name="twitter:description"
      content="Subscribe to receive updates on all upcoming events, workshops, and rituals from the School of Our Divine Infinite Being. Don't miss out on our astrology and tarot sessions."
    ></meta>
      <meta name="robots" content="noindex, nofollow" /> 
    <link rel="canonical" href="https://www.divineinfinitebeing.com/event-subscription" />
</Head>
      <div className={styles.confirmation_container}>
        <div className={styles.confirmation_container_sub}>
          <div className={styles.confirmation_container_inner}>
            {status === "unsubscribed" && (
              <div className={styles.successMessage}>
                <div className={styles.successIcon}>
                  <svg
                    className={styles.checkmark}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    {" "}
                    <circle
                      className={styles.checkmark__circle}
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />{" "}
                    <path
                      className={styles.checkmark__check}
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                </div>
                <h1>Successfully Unsubscribed!</h1>
                <p>{message}</p>
                <Link href="/" className={styles.button}>
                  Go to Homepage
                </Link>
              </div>
            )}

            {status === "error" && (
              <div className={styles.errorMessage}>
                <div className={styles.errorIcon}>⚠️</div>
                <h1>Oops! Something went wrong.</h1>
                <p>{message}</p>
                <Link href="/" className={styles.button}>
                  Go to Homepage
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps({ query }) {
  const {
    action,
    user_id,
    event_id,
    event_slot_id,
    subscription_type,
    subscribed_to_series,
  } = query;

  if (
    action === "unsubscribe" &&
    user_id &&
    event_id &&
    subscription_type &&
    subscribed_to_series
  ) {
    const payload = {
      action: "unsubscribe",
      user_id: user_id,
      event_id: event_id,
      subscription_type: subscription_type,
      subscribed_to_series: subscribed_to_series,
    };

    if (event_slot_id) {
      payload.event_slot_id = event_slot_id;
    }

    console.log("Unsubscription payload:", payload);

    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}event/event-subscription`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      console.log("Unsubscription response:", data);

      if (data.status == "success") {
        return {
          props: {
            status: "unsubscribed",
            message: `You’ve successfully unsubscribed from this ${event_slot_id ? 'event' : 'event series'}.`,
          },
        };
      } else {
        return {
          props: {
            status: "error",
            message: data.message || "Sorry, we couldn’t process your unsubscription. Please try again.",
          },
        };
      }
    } catch (error) {
      return {
        props: {
          status: "error",
          message: "We couldn’t connect to the server. Please check your connection or try again later.",
        },
      };
    }
  } else {
    return {
      props: {
        status: "error",
        message: "This unsubscription link appears to be invalid or expired.",
      },
    };
  }
}

export default ConfirmationPage;
